import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fromJS } from 'immutable';
import { MdLockOutline, MdMailOutline } from "react-icons/md";

// non node modules
import TextInputField from '../../../infra/components/formInput/CustomTextInput'
import LoginAction from '../../../store/action/LoginAction';
import "../../../source/util.css"
// import logocpro from '../../../source/JOD-logo.png'
import logocpro from '../../../source/BRI_WABA_LOGO_NON_BG.png'
import { toast } from "react-toastify";

class LoginComponent extends Component{
    constructor(props){
        super(props)
        this.state = {
            fields: fromJS({
                username: '',
                password: '',
            }),
            errors: fromJS({}),
            errorMsg : '',
            disabled: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        document.title = 'Sign In | SATKOM One Dashboard';
    }

    handleChange(field, value) {
        this.setState({
            fields: this.state.fields.set(field, value),
            errors: this.state.errors.delete(field),
        });
    }

    async handleSubmit() {
        //debugger
        const { fields } = this.state;
        this.setState({
            errors: fromJS({}),
            disabled: true,
        }, async () => {
            const unfilledValues = fields.filter((value) => {
                return value.trim() === '';
            });
            const hasFilledAllValues = unfilledValues.count() === 0;
    
            if (hasFilledAllValues) {
                var response = await this.props.loginUser( fields.get('username'), fields.get('password') );
                
                if(response.ok){    
                    window.location = '/Home'
                }
                else
                {
                    //debugger;
                    if(response.status === 401){
                        this.setState({
                            errorMsg: "Incorrect username password!",
                            disabled: false,
                        })
                        //toast.error("Incorrect username password!", toast.POSITION.BOTTOM_RIGHT)
                    }else{
                        this.setState({
                            errorMsg: "Login Failed!",
                            disabled: false,
                        })
                        //toast.error("Login Failed!", toast.POSITION.BOTTOM_RIGHT)
                    }
                }
            } else {
                let errors = fromJS({});
    
                var msg = ''
                unfilledValues.map((value, field) => {
                    msg += (msg !== '' ? ' , ' : '')   + field 
                    errors = errors.set(field, true);
                });
    
                msg += ' cannot be null'
    
                this.setState({
                    errors: this.state.errors.merge(errors),
                    errorMsg: msg,
                    disabled: false,
                });
            }
        });
    }

    handleFormEntered(event){
        var code = event.keyCode || event.which;
        if(code === 13) { //13 is the enter keycode 
            this.handleSubmit()
        }
    }

    render(){
        const {
            fields,
            errors,
            errorMsg,
        } = this.state;     
        

        return (
            <div className="login100-form validate-form" onKeyPress={(e) => this.handleFormEntered(e)} >
                
                <div className="img-center">
                    <img className="media-object" src={ logocpro } width={ 90 } ></img>
                </div>

                <span className="login100-form-title p-b-30">
                    {/* SATKOM One Dashboard */}
                </span>

                <div className="input-group">
                    <span className="input-group-addon">
                        <MdMailOutline className="material-icons" /> *
                    </span>
                    <div className={"form-line " + (errors.has('username') ? "error" : "")}>
                        <TextInputField className="form-control"
                            field={'username'}
                            value={fields.get('username')}
                            placeholder="username"
                            onChange={(field, value) => this.handleChange(field, value)}
                            hasError={errors.has('username')}
                        />
                    </div>
                </div>

                <div className="input-group">
                    <span className="input-group-addon">
                        <MdLockOutline className="material-icons" /> *
                    </span>
                    <div className={"form-line " + (errors.has('username') ? "error" : "")}>
                        <TextInputField className="form-control"
                            field={'password'}
                            value={fields.get('password')}
                            onChange={(field, value) => this.handleChange(field, value)}
                            placeholder="Password"
                            hasError={errors.has('password')}
                            password
                        />
                    </div>
                </div>

                {/* <div className="container-login100-form-btn">
                    <div className="wrap-login100-form-btn">
                        <div className="login100-form-bgbtn"></div>
                      
                        
                        <button className="login100-form-btn    "
                            value="Login"
                            onClick={this.handleSubmit}>
                            Sign in
                        </button>
                    </div>
                </div> */}

                <div className="col-sm-12 text-center">
                        <label className="lbl-error">
                            { errorMsg }
                        </label>
                </div>

                <div className="form-group">
                {errors.valueSeq().map((error) => {
                            if (typeof (error) === "string") {
                                return (
                                    <div key={`error-${error}`} className={"formError"}>
                                        {error}
                                    </div>
                                );
                            }
                        })}

                <input className="btn btn-warning btn-register btn-large" disabled={this.state.disabled} value="Sign In" onClick={this.handleSubmit}>
                </input>
                </div>

                <div className="frgt-pswd">
                    <a href="#">
                        Forgot Password?
                    </a>
                </div>
            </div>
          );
    }
}

export default connect(
    (state) => {
        return {
            isLoggedIn: state.auth.isLoggedIn,
        }
    },
    dispatch => bindActionCreators({
        loginUser: LoginAction,
    }, dispatch),
)(LoginComponent);